import DarkBluePaintSvg from './svg/DarkBluePaintSvg';
import OrangePaintSvg from './svg/OrangePaintSvg';
import {
  Container,
  Content,
  Main,
  OrangeWrapper,
  DarkBlueWrapper,
  YellowWrapper,
  LightBlueWrapper,
  PurpleWrapper,
} from './NotFound.styles';
import LightBluePaintSvg from './svg/LightBluePaintSvg';
import PurplePaintSvg from './svg/PurplePaintSvg';
import YellowPaintSvg from './svg/YellowPaintSvg';
import Footer from './footer/Footer';
import LostHero from './hero/LostHero';
import ErrorHero from './hero/ErrorHero';
import LostHeroInfo from './info/LostHeroInfo';
import ErrorHeroInfo from './info/ErrorHeroInfo';

export enum ErrorType {
  NOT_FOUND = 'NOT_FOUND',
  ERROR = 'ERROR',
}

const NotFound = ({ errorType }: { errorType?: ErrorType }) => {
  return (
    <Container>
      <Content>
        <Main>
          {errorType === ErrorType.NOT_FOUND && (
            <>
              <LostHero />
              <LostHeroInfo />
            </>
          )}
          {errorType === ErrorType.ERROR && (
            <>
              <ErrorHero />
              <ErrorHeroInfo />
            </>
          )}
        </Main>

        <Footer />
      </Content>

      <PurpleWrapper>
        <PurplePaintSvg />
      </PurpleWrapper>

      <LightBlueWrapper>
        <LightBluePaintSvg />
      </LightBlueWrapper>

      <YellowWrapper>
        <YellowPaintSvg />
      </YellowWrapper>

      <DarkBlueWrapper>
        <DarkBluePaintSvg />
      </DarkBlueWrapper>

      <OrangeWrapper>
        <OrangePaintSvg />
      </OrangeWrapper>
    </Container>
  );
};

NotFound.defaultProps = {
  errorType: ErrorType.NOT_FOUND,
};

export default NotFound;
